<template>
  <div class="card" v-on:click="open">
    <div class="card-header">
      <div class="row justify-content-between">
        <span class="col game-title">Ajouter une partie</span>
      </div>
    </div>
    <div class="card-body d-flex align-items-center">
      <div v-if="!opened" class="add text-center flex-fill">
        +
      </div>
      <div v-else>
        <div class="row">
          <div class="col-12">
            <form v-on:submit="createGame">
              <div class="form-group">
                <label for="gameName">Nom de la partie</label>
                <input type="text" class="form-control" id="gameName"
                maxlength="70"
                placeholder="nom..." v-model="gameName">
              </div>
              <div class="form-group">
                <label for="startIn">Commencer dans</label>
                <select class="form-control" id="startIn" v-model="startIn">
                  <option value="-1" selected>Sélectionnez</option>
                  <option value="-10">On verra...</option>
                  <option value="0">Maintenant</option>
                  <option v-for="a in [1,2,3,4,5,6,7,8,9,10]" v-bind:key="a" v-bind:value="a">
                    {{a}} min</option>
                </select>
              </div>
              <div class="form-group">
                <label for="roundTime">Temps par tour</label>
                <select class="form-control" id="roundTime" v-model="roundTime">
                  <option value="-1" selected>Sélectionnez</option>
                  <option value="75">75s</option>
                  <option value="90">90s</option>
                  <option value="120">2 min</option>
                  <option value="180">3 min</option>
                </select>
              </div>
              <div class="form-check">
                <input class="form-check-input" type="checkbox"
                  id="onlyFriends" v-model="onlyFriends">
                <label class="form-check-label" for="onlyFriends">
                 <span class="font-italic">Option:</span>
                 Cochez pour restreindre l'accès à vos amis seulement.
                </label>
              </div>
              <div class="form-group mt-2">
                <label for="gamePassword"><span class="font-italic">Option:</span>
                restreindre l'accès par un mot de passe</label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <div class="input-group-text lock">&#x1F512;</div>
                  </div>
                  <input type="text" class="form-control" id="gamePassword"
                  maxlength="70"
                  placeholder="Clé d'accès..." v-model="gamePassword">
                </div>
              </div>
              <div class="row">
                <div class="col-12 text-center">
                  <input type="submit" v-bind:class="buttonClass" value="Créer" />
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import iam from '../iam';

export default {
  name: 'AddGameCard',
  data() {
    return {
      opened: false,
      gameName: undefined,
      gamePassword: undefined,
      startIn: -1,
      roundTime: -1,
      onlyFriends: false,
      block: false,
    };
  },
  computed: {
    buttonClass() {
      return {
        btn: true,
        'btn-link': true,
        inactive: !(this.gameName && this.roundTime > 0 && !this.block),
        active: this.gameName && this.roundTime > 0 && !this.block,
      };
    },
  },
  methods: {
    open() {
      this.opened = true;
    },
    createGame(event) {
      event.preventDefault();
      if (this.gameName && this.roundTime > 0 && !this.block) {
        this.block = true;
        this.$http.post(`${process.env.LCT_API_URL}/active-games`, {
          startIn: this.startIn >= 0 ? this.startIn : undefined,
          gameName: this.gameName,
          password: this.gamePassword ? this.gamePassword : undefined,
          onlyFriends: this.onlyFriends,
          creator: iam.getConnectedUser().username,
          roundTime: this.roundTime,
          description: `Partie créée par ${iam.getConnectedUser().username}`,
        }).then(res =>
          Promise.all([res.data, this.$http.post(`${process.env.LCT_API_URL}/game-players`, {
            username: iam.getConnectedUser().username,
            picture: iam.getConnectedUser().picture,
            activeGameId: res.data.id,
            password: this.gamePassword ? this.gamePassword : undefined,
          })]))
          .then(([game]) => {
            if (this.startIn >= 0) {
              this.$router.push(`/games/${game.id}`);
            } else {
              this.$router.push(`/prepare-games/${game.id}`);
            }
          });
      }
      return false;
    },
  },
};
</script>

<style scoped>
.inactive{
  color: #757575;
}
.inactive:hover{
  color: #757575;
  text-decoration: none;
}
.active{
  color: #CE0F69;
}
.creator{
  color: gray;
}
.card-body{
  min-height: 130px;
}
.game-title {
  color: #757575;
  font-weight: 500;
  letter-spacing: .21px;
  font-family: Roboto,arial,sans-serif;
}
.card:hover {
  cursor: pointer;
  border-color: #CE0F69;
}
.add{
  font-size: 3rem;
  font-weight: 200;
  color: #5dc596;
}
</style>



// WEBPACK FOOTER //
// src/components/AddGameCard.vue